import { baseUrl } from '@/utils/seting';
export const translateObj = {
    //头部信息
    menuList: [
        {
            name: '首页',
            children: [],
            link: 'index'
        },
        {
            name: '产品展示',
            children: [],
            link: 'productList'
        },
        {
            name: '营销服务',
            children: [
                { name: '主机市场', children: [], link: 'marketing' },
                { name: '后市场', children: [], link: 'marketing' },
                { name: '海外市场', children: [], link: 'marketing' },
                { name: '客服中心', children: [], link: 'marketing' }
            ]
        },
        {
            name: '党建及企业文化',
            children: [
                { name: '关于我们', children: [], link: 'culture' },
                { name: '党建之窗', children: [], link: 'culture' },
                { name: '文化建设', children: [], link: 'culture' },
                { name: '企业荣誉', children: [], link: 'culture' },
            ]
        },
        {
            name: '技术支持',
            children: [
                { name: '产品研发', children: [], link: 'technology' },
                { name: '试验能力', children: [], link: 'technology' },
                { name: '检测能力', children: [], link: 'technology' },
                { name: '装备能力', children: [], link: 'technology' },
                // { name: '质量保障', children: [], link: 'technology' },

            ],
        },
        {
            name: '体系保障',
            children: [
                { name: '质量体系', children: [], link: 'systemGuarantee' },
                { name: '环境体系', children: [], link: 'systemGuarantee' },
                { name: '安全体系', children: [], link: 'systemGuarantee' }
            ]
        },
        {
            name: '新闻公告',
            children: [
                { name: '企业新闻', children: [], link: 'newsList' },
                // { name: '行业动态', children: [], link: 'newsList' },
                { name: '信息公告', children: [], link: 'newsList' },
            ],
        },
        {
            name: '招贤纳士',
            children: [
                { name: '人才理念', children: [], link: 'recruit' },
                { name: '幸福文化', children: [], link: 'recruit' },
                { name: '在聘岗位', children: [], link: 'recruit' },
                { name: '招聘咨询', children: [], link: 'recruit' },
            ],
        },
    ],
    //底部信息
    footerInfo: {
        companyName: '重庆长江轴承股份有限公司',
        menuList: ["首页", "产品展示", "营销服务", "党建及企业文化", "技术支持", "体系保障", "新闻公告", "招纳贤士"],//菜单列表
        contactList: [
            {
                url: require('@/assets/location.png'),
                info: "地址：重庆南岸区蔷薇路11号"
            },
            {
                url: require('@/assets/contact.png'),
                info: "电话：023-88069999 023-88067888"
            },
            {
                url: require('@/assets/fax.png'),
                info: "传真：023-88069666 023-88069995"
            }
        ],//联系信息列表
        copyright: ' 版权所有©2015 重庆长江轴承股份有限公司 技术支持：重庆龙亨科技有限公司  E-mail:master@cjb.com.cn',//版权信息
        recordNum: '  备案号： 渝ICP备11003522号',//备案号
    },
    //海外市场部
    overseasMarketObj: {
		img: require('@/assets/overseasMarket/overseasMarket.png'),
        desc: `海外事业部隶属于销售公司，主要为大众、福特、通用、丰田、本田、日产、捷豹路虎、博格华纳、麦格纳、坦迪斯和比亚乔等国际汽摩主机客户和一级配套企业提供系统轴承解决方案，同时凭借强大的全球物流网络及第三方工程服务公司，能够提供全过程的物流服务和及时的在线支持和售后服务。`,
        overseasList: [
            { title: "产品应用：汽车变速箱，分动箱，扭矩管理器，离合起，底盘系统；通用机械等" },
            { title: "出口国家：美国，墨西哥，瑞典，匈牙利，意大利，奥地利，越南，印度，韩国，泰国等" },
            { title: "CJB出口产品：单列深沟球轴承，双列球轴承" },
            { title: "年出口数量：超过1000万个轴承" },
            { title: "年出口金额：超过2000万美元" },
            { title: "业务经理：冯志强" },
            { title: "联系方式：18580707688" },
            { title: "邮箱：channy@cjb.com.cn" }
        ],
    },
    //后市场部
    afterMarketObj: {
        title: '后市场事业部',
        desc: '后市场事业部隶属于销售公司，专门为除主机厂外的二/三级配套企业服务，现在中国市场及海外市场有30多个经销商，为300多家中小型及微型企业提供服务，以及为全国超过 1000家汽车/摩托车4S店及维修点提供维修轴承，经销商分布于：黑龙江、吉林、辽宁、北京、河北、湖南、山东、安徽、上海、江苏、浙江、江西、重庆、云南、贵州、陕西 及中东地区。<br />主要产品设计机车用轴承（包括变速箱、轮毂轴承、发动机、电机、方向机、桥用轴承）摩托车全车轴承，工业电动机，减速机，水泵轴承，2,3,7类轴承。',
        productList: [
            {
                name: "汽车轮毂轴承1",
                imgUrl: `${baseUrl}oem1.png`
            },
            {
                name: "汽车轮毂轴承2",
                imgUrl: `${baseUrl}oem2.png`
            },
            {
                name: "汽车轮毂轴承3",
              imgUrl: `${baseUrl}oem3.png`
            },
            {
                name: "汽车轮毂轴承4",
              imgUrl: `${baseUrl}oem4.png`
            },
            {
                name: "汽车轮毂轴承5",
              imgUrl: `${baseUrl}oem5.png`            },

        ],
        contactList: [
            {
                label: '联系人',
                value: '陈红兵'
            },
            {
                label: '联系电话',
                value: '13808384486'
            },
            {
                label: '邮箱',
                value: 'cjbchbing@163.com'
            },
            {
                label: '营销范围',
                value: '后市场及服务'
            }
        ]
    },
    //主机市场
    hostMarketObj: {
        title: '主机市场',
        desc: `主机事业部隶属于销售公司，主要为国内各汽摩整车客户、汽摩零部件总成客户提供动力系统、传动系统、底盘系统的可靠、先进、环保、安全的轴承解决方案。事业部在国内围绕着主机客户划分各营销片区，分别在西南、华南、中南、华东、华北、东北等地区设立营销中心，组建营销团队，及时为主机客户提供全方位服务`
    },
    //客服中心
    customerServiceObj: {
        title: '重庆长江轴承股份有限公司',
        contactList: [
            {
                name: "地址：重庆市南岸区蔷薇路11号",
                imgUrl: require("@/assets/contactLocation.png")
            },
            {
                name: "联系人：杨维杰",
                imgUrl: require("@/assets/contactPerson.png")
            },
            {
                name: "联系方式：13923488846",
                imgUrl: require("@/assets/contactPhone.png")
            },
            {
                name: "邮箱：Yangwj909@126.com",
                imgUrl: require("@/assets/contactEmail.png")
            }
        ]
    },
    // 关于我们
    aboutUs: {
        title: '关于我们',
        // contents: [
        //     { id: 1, content: '重庆长江轴承股份有限公司（以下简称长江轴承）成立于1990年，原属于中港合资企业，于2006年改制成股份公司，现位于重庆市南岸区蔷薇路11号，占地面积 263亩，现有员工1185人，注册资本2.35亿元，系重庆机电控股（集团）公司所属重庆工投机电零部件产业集团有限公司控股企业。' },
        //     { id: 2, content: '长江轴承主要生产高品质低噪音密封深沟球轴承、角接触球轴承、轮毂轴承单元、圆锥滚子轴承及变型品种。产品广泛应用于汽车、摩托车、机床设备、工程机械、 电机、通机等行业，为国内各大汽车主机厂和美国通用（GM）、博格华纳（BORG-WARNER）、加拿大麦格纳（MAGNA）、日本爱信（Aisin Seiki Co.）、韩国岱 摩斯（DYMOS）等世界一流企业配套，在国内、国际市场上具有较高的占有率和美誉度。' },
        //     { id: 3, content: '长江轴承是国家高新技术企业，设立有“重庆市博士后科研工作站”，拥有“国家认可实验室”“省级轴承研发中心”“重庆汽车传动轴承工程技术研究中心” “汽车轮毂轴承试验检测中心”四大技术创新平台，拥有专利117件，其中发明专利3项。' },
        //     { id: 4, content: '公司“CJB”品牌被国家工商总局认定为“中国驰名商标”，9次评为重庆市工业五十强，2014、2017年度两次荣获博格华纳“全球优秀供应商”称号，荣获中国轴 承工业协会“中国轴承行业2015-2016年度优秀企业”“中国轴承2017年市场营销30强”“工程机械轴承‘十三五’（2015—2020）期间优秀供应商”等称号。' }
        // ]

      // 2024.12.10修改
    //   contents:[
    //     {id:1,content:'重庆长江轴承股份有限公司（以下简称长江轴承）成立于1990年，位于重庆市南岸区蔷薇路11号，占地面积263亩，注册资本9.5亿元，现有员工1400余人，系重庆机电控股（集团）公司控股企业。'},
    //     {id:2,content:'长江轴承具备年产1亿套（件）轴承、汽车零部件的能力。主要生产高品质低噪音密封深沟球轴承、角接触球轴承、轮毂轴承单元、圆锥滚子轴承及变型品种，产品应用于汽车、摩托车、机床设备、工程机械、电机、通机等行业，产品品质100%达P6级、80%达P5级精度。坚持大客户培育和“交钥匙”工程，为国内上汽、长安、吉利、奇瑞、北汽等各大汽车主机厂和美国通用、博格华纳、加拿大麦格纳、日本爱信、韩国岱摩斯等世界一流企业配套，在国内、国际市场上具有较高的占有率和美誉度。'},
    //     {id:3,content:'长江轴承以“成为世界一流轴承制造基地”的企业愿景，经过多年行业深耕，成为了国家高新技术企业，拥有有效专利125件，其中发明专利12项，主持制定我国轴承行业国家标准1项，参与制订/修订我国轴承行业国家标准17项、行业标准7项。设立有“重庆市博士后科研工作站”，拥有“国家认可实验室”“重庆市企业技术中心”“重庆汽车传动轴承工程技术研究中心”“汽车轴承重庆市工程实验室”“省级汽车轴承工业设计中心”五大技术创新平台，具备对轴承各种性能指标进行独立分析、研究的能力。'},
    //     {id:4,content:'长江轴承“CJB”品牌被国家工商总局认定为“中国驰名商标”，9次获评“重庆市工业五十强”，2014、2017、2023年度三次荣获博格华纳“全球优秀供应商”称号，2019年获评“AAA级重庆市和谐劳动关系企业”、“工程机械轴承‘十三五’期间优秀供应商”，获评重庆市“企业创新奖”、重庆市南岸区“制造业跃升发展领头羊企业”、市国资委“先进基层党组织”、重庆市工业营销协会“抗疫抗旱闭环生产保供应优秀单位”“诚信营销先进企业”、中信泰富“金牌客户奖”、麦格纳“新产品开发贡献奖”“质量优胜奖”、上汽变速器“优秀质量奖”、机电集团“先进基层党组织”“先进集体”等众多荣誉。'}
    //   ]
    // 20260803修改
       contents:[
        {id:1,content:'重庆长江轴承股份有限公司（以下简称长江轴承），成立于1990年，坐落于南岸区茶园新区，占地面积263亩，注册资本9.5亿元，资产总额20.97亿元，现有员工1500人，系重庆机电控股（集团）公司控股企业，承担机电集团大营销平台战略任务。'},
        {id:2,content:'长江轴承锚定新能源汽车轴承赛道，坚持创新驱动、数智赋能，专注于深沟球轴承、轮毂轴承研发制造，年产1亿套（件）轴承。坚持国内国际双轮驱动，主要配套长安、上汽、吉利、奇瑞、北汽、比亚迪、长城、零跑、上汽通用五菱等国内主流车企及美国通用、博格华纳、加拿大麦格纳、德国大众、日本爱信精机、韩国岱摩斯等国际一流企业，汽车传动、轮毂轴承细分市占率11%，国内前十大乘用车客户市占率11.4%。'},
        {id:3,content:'长江轴承为国家高新技术企业、西南地区最大轴承生产基地、国务院国资委基层联系点、重庆市科改示范企业、重庆市双百企业。建有“国家认可实验室”“重庆市博士后科研工作站”“重庆市企业技术中心”“重庆汽车传动轴承工程技术研究中心”“汽车轴承重庆市工程实验室”“省级汽车轴承工业设计中心”“重庆市现代制造业检验检测公共服务平台”等七大技术创新平台，拥有有效专利112件、4个数字化车间。'},
        {id:4,content:'长江轴承“CJB”品牌被国家工商总局认定为“中国驰名商标”，是全球唯一一家连续三次荣获博格华纳“优秀供应商”企业，“AAA全国模范劳动关系和谐”企业；获评重庆市“企业创新奖”、重庆市国资委“先进基层党组织”、南岸区“制造业跃升发展领头羊企业”、机电集团“先进基层党组织”“先进集体”、中信泰富“金牌客户奖”、麦格纳“质量优胜奖”等荣誉。'},
    {id:5,content:'近年来，长江轴承坚决贯彻重庆市委“三攻坚一盘活”改革突破部署，牢固树立和践行正确政绩观，坚守发展定位、校准前行航向，直面改革难点、攻坚发展堵点，奋力走出一条高质量改革转型发展新路径。“十五五”时期，长江轴承将认真贯彻落实机电集团“12358”战略总纲，锚定建设成为世界一流轴承制造基地目标，全面贯彻“扶摇”“破天”“星汉”三大核心任务，聚焦“深沟球轴承”“轮毂轴承单元”“其他汽车零部件”“战新产业”四大产业布局，系统构建与培育三大增长曲线，力争2030年营业收入突破50亿元，助力机电集团建设成为中国一流的装备集团，为现代化新重庆建设作出更大长江轴承贡献。'},
    ]


    },
    partyBuilding: {
        title: '公司党委介绍',
        contents: [
            { id: 1, content: '重庆长江轴承股份有限公司设有党委1个，党支部7个，共有党员180余人。公司党委坚持以习近平新时代中国特色社会主义思想为指导，锚定"建设世界一流轴承制造基地"愿景，全力打造"先锋领航·重塑致远"党建主品牌，构建"一主统领、七支赋能"党建品牌矩阵，7个党支部分别围绕"护、链、铸、精、创、攻、智"七个方向，推动党建工作从"有形覆盖"向"有效覆盖"深度转换，切实把党建优势转化为发展胜势。公司党委、所属党支部荣获市国资委、机电集团党委"先进基层党组织"称号7次，所属5个支部荣获市国资委"红岩先锋·四强四好"党支部命名。' },
            { id: 2, content: '公司党委坚持深入学习贯彻习近平新时代中国特色社会主义思想、习近平党建思想和党的二十大、二十届历次全会精神，全面贯彻落实党中央重大决策部署及市委、市国资委、上级集团党委工作要求，紧扣机电集团"12358"战略总纲和公司"13349"战略规划，全面落实机电集团党建统领高质量发展"5543"和公司"四个一"综合考核评价体系，切实把战略蓝图、考核闭环、政绩导向三者贯通起来，以三条曲线增长检验发展质效，以正确政绩观持续推动党建质量系统跃升，以高质量党建引领保障公司高质量发展行稳致远！' }
        ]
    },
    //愿景、精神、使命
    visionList: [
        {
            id: 0,
            title: "企业精神",
            subs: [
                {
                    id: 0,
                    subTitle: '精诚团结、求实创新、和谐高效、追求卓越',
                    desc: `企业精神是现代意识与企业个性相结合的一种群体意识，是企业向心力、凝聚力、使命感和责任感的集中体现，是企业在成长过程中形成的代表全体员工心愿、意 志，并成为激发全体员工积极性和创造性的无形力量，是企业哲学、价值观念和道德观念的高度概括，反映了全体员工的共同追求和共同认识，是企业的灵魂，是企业文化的旗帜。`
                },
                { id: 1, subTitle: "精诚团结", desc: `致力于全体人员心、气、神合一，做到相互帮助、相互促进，紧密团结，为了共同目标，充分发挥出浑然一体的战斗力。` },
                { id: 2, subTitle: "求实创新", desc: `注重实际情况的调研，深入生产经营实践，一切从实际出发。在尊重经验的基础上，突出创新，在思想观念、技术和管理上，都要有新思路、新举措，以求取新的 效果。创新是企业的灵魂，是企业的核心竞争力。` },
                { id: 3, subTitle: "和谐高效", desc: `和谐社会首先离不开构建和谐企业，为促进企业和谐健康发展，公司提出了向节约型企业方向发展，做到量产高、效率高、效益高、绿色环保好，各个方面科学、 协调发展。` },
                { id: 4, subTitle: "追求卓越", desc: `每个员工都要以“完美”为目标，不断提高和完善自己，不断改进和完善本职工作。我们整个企业也要以“最优”为追求境界，锲而不舍地扬长补短，改进提高， 逼近“完美”。` }
            ]
        },
        {
            id: 1,
            title: "企业使命",
            subs: [
                { id: 0, subTitle: "对顾客、股东、员工、社会负责", desc: `企业使命是构成企业理念识别中的最基本的出发点，是企业行动的原动力。企业使命就是要表达企业对顾客、股东、员工及社会的责任感。具体来说，就是为顾客提 供优质的产品和服务，为股东创造更多的利润，为员工谋求更好的工作环境和生活环境，为供应商提供发展机会，搭建发展平台，切实履行社会责任。` },
                { id: 1, subTitle: "让旋转的世界更安全、安静、持久", desc: `世界本身是旋转运动的，旋转的机械离不开轴承，而轴承的基本要求和主要性能指标就是安全、低噪音、长寿命，这也是公司致力于轴承研究的根本出发点，表明了 CJB产品具有过硬的品质以及良好的信誉，体现了CJB追求与世界名牌并驾齐驱的信心和决心。` }
            ]
        },
        {
            id: 2,
            title: "企业愿景",
            subs: [
                { id: 0, subTitle: "成为世界一流轴承制造基地", desc: `企业愿景是建立在企业价值观基础之上，并为全体员工所一致为之努力的目标，它指明了企业前进的方向，并激励着全体员工为实现这一目标而付之扎实有效的行 动。我们的愿景就是要建成世界一流轴承制造基地，从规模、技术、管理、效率等各个方建设国际一流企业，并以此激励全体员工为之奋斗和拼搏。` }
            ]
        },
        {
            id: 3,
            title: "企业价值观",
            subs: [
                { id: 0, subTitle: "诚信 创新 奉献", desc: `价值观是人们对是与非、好与坏、对与错的基本判断。企业价值观的内涵是全体（或多数）员工赞同的关于“企业的价值在于什么以及哪些对象对于企业来说有价值” 的看法。` },
                { id: 1, subTitle: "诚信", desc: `体现在对工作负责，对客户、供应商、同事负责，相互能够直率与坦诚地沟通，保守公司秘密，不隐瞒自己的过失并敢于承认失败和承担责任，忠诚于企业。` },
                { id: 2, subTitle: "创新", desc: `创新是企业发展的不竭动力，体现在具有开放的态度，对新知识、技术、信息及一切新生事物持欢迎、接纳、鼓励的态度，主动学习，追求速度和效率，敢于冒险。` },
                { id: 3, subTitle: "奉献", desc: `企业的发展离不开员工的理解与奉献，倡导员工发扬无私、无怨、无悔的精神，用行动体现企业是我“家”的精神理念。而企业也会竭尽全力搭建平台，以爱护、 支持、帮助员工实现自身价值和远大理想。` }
            ]
        },
        {
            id: 4,
            title: "核心竞争力",
            subs: [
                { id: 0, subTitle: "团队建设 持续创新 品牌打造", desc: `“核心竞争力”是企业在经营过程中形成的，不易被竞争对手仿效的，能带来超额利润的独特能力；是企业在生产经营、 新产品研发、售后服务等一系列营销过程和 多种决策中形成的；具有独特优势技术、文化和机制，并能决定巨大资本能量和经营实力。` },
                { id: 1, subTitle: "团队建设", desc: `企业的价值需要全体员工共同创造，一个优秀的企业离不开一支优秀的团队，长江轴承致力于打造一支团结、奋进、创新、执行和以人为本的团队。良好的团队凝聚 力是战胜困难的重要法宝，强大的知识团队是创新的基础和源泉。` },
                {
                    id: 2, subTitle: "持续创新", desc: `整个世界是发展变化的，要发展就要创新，没有创新就不可能取得发展，形成自己的优势，而持续创新能力更是衡量一个企业发展潜
                力和竞争力的重要标准，持续创 新才能够使企业适应并引领市场潮流，体现其核心竞争力优势，保证企业立于不败之地。<br/><br/>
                1、工艺格局的持续创新：善于在关键工艺环节精取国际先进技术和装备，与国内优秀设备和经改造后的设备相匹配，组合成其工艺能力与国际水平相当的各种生产 线、
                自动线，形成了具有中国特色的“中西结合”制造工艺新格局，以相对低的投入获得较高的工程能力，构建了低成本、高起点的典范。<br/><br/>
                2、工艺技术的持续创新：在引进设备的消化吸收方面研究出一套自己独特的方法，不断改进工装、模具和维护、检修技术，不断自我完善、自我提高，做到领先于
                 国内，成为行业的技术窗口。<br/><br/>
                 3、持续创新使企业制造技术迈向国际水平：持续不断的群众性技术革新、技术改造等创活动，使企业制造工艺水平，
                 劳动生产率水平，产品质量水平和降低成本的 水平不断提升，真正实践了“CJB与世界名牌并驾齐驱”的战略方针。`},
                { id: 3, subTitle: "品牌打造", desc: `优质的产品质量、良好的企业形象、令人称羡的信誉及具有影响力的品牌效应是建设一流企业的重要组成部分。而品牌无疑成为企业的一面旗帜，成为企业产品质 量、技术先进的化身。“CJB”品牌多次被国家，行业和地方评为“名牌”、“精品”，在国内甚至国际上都有相当的影响。摩托车关键轴承（即发动机曲轴轴承） 在国内市场占有率已经超过60%，微车变速器和制动器轴承领域接近60%，“CJB”产品质量在国内摩托车轴承行业一直雄居榜首，已成为国内该行业第一品牌， “CJB”产品在美国市场也被公认为“中国制造的最好的球轴承”。但是，我们仍将继续致力于“CJB”品牌打造，立足国内，走向世界。` }
            ]
        },
        {
            id: 5,
            title: "经营理念",
            subs: [
                {
                    id: 0, subTitle: "以人为本 市场为先 精益求精 追求共赢", desc: [
                        { id: 0, title: "以人为本", desc: `人才是企业之本，市场取胜最终表现为人才取胜。公司无论是在创业之初还是在今后的发展道路上，始终依靠的是人才。公司不仅搭建了人才成长的平台，而且对人 才的培养、关心、爱护、尊重都得到不断创新和完善，尤其在人才激励机制上更彰显了企业特性。` },
                        { id: 1, title: "市场为先", desc: `市场是企业赖以生存的土壤。企业的发展首先应该立足于市场需要，符合大众之所需，不能盲目自大，但也不能一味步市场后尘，需要具有极强的市场敏感性和前瞻 性。` },
                        { id: 2, title: "精益求精", desc: `企业的发展是一个不断完善自我的过程，也是一个精益的过程。既强调产品精益求精，又强调管理、行为各个方面的效率和效益，以最终在企业形成精益的思想，作 为一种理念和文化在企业发展过程中得以延续。` },
                        { id: 3, title: "追求共赢", desc: `随着世界经济全球一体化进程加快，企业在发展过程中，自身的发展并不一定代表真正的全面发展，企业的发展是自身及所有供应链环节的共同发展，任何一个环节 落后都会成为发展的绊脚石，因此，企业在经营发展过程中强调各个环节同步发展，实现共赢。` }
                    ]
                }
            ]
        },
        {
            id: 6,
            title: "质量、环境、职业健康安全方针",
            subTitle: '公司的质量、环境、职业健康安全方针：预防为主；持续改进；全员参与；遵守法律法规；社会、客户、员工满意',
            subs: [
                { id: 0, subTitle: "预防为主", desc: `是保证产品质量、实现污染预防、降低和杜绝职业健康安全危害的基础。通过对潜在质量、环境、职业健康安全风险的识别和措施的制定、落实，消除导致不符合产 生的因素，确保产品满足“零缺陷”、环境和职业健康安全“零事故”的原则。` },
                { id: 1, subTitle: "持续改进", desc: `持续改进是公司取得发展的关键和有力保证，改进是全方位的，包括技术、工艺的改进，生产组织的改进，管理方法的改进，营销策略的改进等等，公司全体员工应 树立持续改进的开放心态，不断提升公司质量、环境和职业健康安全的管理绩效。` },
                { id: 2, subTitle: "全员参与", desc: `质量、环境和职业健康安全目标的实现不能单靠某个人，质量、环境和职业健康安全的控制贯穿于各个环节，涉及到每一位员工，应营造全员参与三大管理体系建立 与运行的氛围，充分发挥每位员工在各自岗位上的作用。` },
                { id: 3, subTitle: "遵守法律法规", desc: `充分识别并严格遵守适用于公司产品和生产经营活动中质量、环境和职业健康安全的法律法规。` },
                { id: 4, subTitle: "社会、客户、员工满意", desc: `体现了公司建立和运行一体化管理体系的最终目的。` }
            ]
        },
        {
            id: 7,
            title: "质量目标",
            subs: [
                { id: 0, subTitle: "追求零缺陷、CJB与世界名牌并驾齐驱", desc: `“追求零缺陷”，就是在各工作环节、生产过程中以预防为主和持续改进，实施产品零缺陷工程，追求产品零缺陷是“客户满意”的最终体现。 “与世界名牌并驾齐驱”，就是技术水平、管理水平、产品实物质量、服务质量及品牌信誉，与指定的世界著名轴承企业保持同一水平。` }
            ]
        },
        {
            id: 8,
            title: "环境目标",
            subs: [{ id: 0, subTitle: "排放达标，并持续改进环境绩效", desc: `` }]
        },
        {
            id: 9,
            title: "职业健康安全目标",
            subs: [{ id: 0, subTitle: "零事故、零伤害、零职业病", desc: `` }]
        },
        {
            id: 10,
            title: "团队意识",
            subs: [{ id: 0, subTitle: "凝聚产生力量，团结成就理想", desc: `团队成员竭尽所能的贡献是确保团队走向胜利的前提，这种前提需要团队的凝聚力，团队凝聚才能产生合力，产生激情，产生力克难关的勇气， 才能成就集体和个人的理想。` }]
        },
        {
            id: 11,
            title: "员工行为规范",
            subs: [{ id: 0, subTitle: "", desc: `遵纪守法，敬业爱岗，文明生产，健康向上，勤思善学，诚信自强，团结和谐，热爱长江` }]
        },
        {
            id: 12,
            title: "长江轴承工作行为导向",
            subs: [{ id: 0, subTitle: "", desc: `践行一种精神：奉献；培养一种思维：转变；树立一种意识：危机；保持一种状态：投入；倡导一种风气：改善；强化一种能力：执行；坚定一种追求：目标； 营造一种氛围：和谐。` }]
        }
    ],
    //产品研发
    researchObj: {
        teamTitle: "团队介绍",
        teamDesc: "重庆长江轴承股份有限公司拥有省级技术中心，重庆市汽车传动轴承工程技术研究中心和汽车轴承重庆市工程实验室三大市级研发平台和一个国家认可实验室，拥有工程技术人员205人，形成以技术中心为核心，包含质量管控部，生产运行部各分厂，覆盖产品设计、制造加工、检测检验、性能试验、技术开发等要素的技术创新体系。运用ROMAX模拟分析软件实现CAE分析及设计方案，具备与用户同步开发能力；主导及参与制定标准22个，其中国家标准14个，行业标准8个；拥有专利133项，其中发明专利3项，拥有数名行业专家，其中总工程师享受国务院津贴",
        productTitle: "产品研发",
        productDesc: "公司设有省级轴承研发中心和国家认可实验室，专门从事轴承产品研究、设计与开发、轴承制造工艺技术的研究和开发、轴承材料和摩擦润滑技术研究、 产品应用研究和产品失效分析、轴承试验与检测分析等。从事产品和过程设计/开发的工程技术人员90余名，在MT，AT,AMT,DCT,CVT变速箱领域， 分动箱领域、轮毂轴承领域参与多家用户项目同步开发。",
        productList: [
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/a3054e70-081a-44db-98c6-57d231ba3114.png',
                title: 'AT轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/9ecef7ce-f922-4c1b-af76-263848b174f1.png',
                title: 'CVT轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/c2191d2d-41df-4cc8-85d7-d70f96e6d7cf.png',
                title: 'DCT轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/9cb416e5-d9bf-4a93-be4b-31c10aedcfc9.png',
                title: 'EDCT轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/6e588331-5613-461c-ba6b-f8d3b16b0bcb.png',
                title: 'MT轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/dad04f48-d930-41ec-a530-9c4eeb9b63d1.png',
                title: '二代轮毂轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/fac0e31e-b42b-4fb7-8626-33e716cdd831.png',
                title: '减速器轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/7ef7b87e-3ae7-43c2-a866-a85ac649f36d.png',
                title: '链条轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/74d64c1c-404a-4c6d-be17-e3005e1bba20.png',
                title: '轮毂轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/ec0ce73a-9201-4de2-82e8-07636c957fe7.png',
                title: '三代轮毂轴承'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/f848c4ff-ba31-4018-b0db-71ab12205677.png',
                title: '新能源汽车驱动系统三合一'
            },
            {
                imgUrl: 'http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2022/01/27ab1109-2470-4caf-a07e-178a7caf9e3a.png',
                title: '一代轮毂轴承'
            },

        ],
        patentTitle: "知识产权",
        patentDesc: "主导制定了汽车变速箱轴承单元技术标准、参与制定了变速箱轴承试验及评定方法",
        patentList: [
            require('@/assets/research/1.png'),
            require('@/assets/research/2.png'),
            require('@/assets/research/3.png'),
            require('@/assets/research/4.png')]
    },
    //试验能力
    experimentObj: {
        abilityTitle: "轴承试验能力介绍"
	},
    //检测能力
    testingObj: {
        swiperList: [
            {
                imgs: [
                    require("@/assets/TechnicalSupport/detect/1.jpg"),
                    require("@/assets/TechnicalSupport/detect/2.jpg"),
                    require("@/assets/TechnicalSupport/detect/3.png"),
                    require("@/assets/TechnicalSupport/detect/5.jpg"),
                    require("@/assets/TechnicalSupport/detect/6.jpg"),
                    require("@/assets/TechnicalSupport/detect/7.png")
                ]
            }
        ]
    },
    //装备能力
    equipmentObj: {
        swiperList: [
            {
                imgs: [
                    require("@/assets/TechnicalSupport/equipment/forgeShop/1.png"),
                    require("@/assets/TechnicalSupport/equipment/forgeShop/2.png")
                ],
                title: "锻造车间",
                subTitle: "Forging",
                desc: "整个锻造过程采用的是世界领先水平的中频感应加热装置与高速热锻机组成三条完整的全自动生产线。"
            },
            {
                imgs: [
                    require("@/assets/TechnicalSupport/equipment/Turning/1.png"),
                    require("@/assets/TechnicalSupport/equipment/Turning/2.png")
                ],
                title: "车加工",
                subTitle: "Turning",
                desc: "车碾加工率先从日本引进冷碾机床，并配备全自动加工线。"
            },
            {
                imgs: [
                    require("@/assets/TechnicalSupport/equipment/HeatTreatment/1.png"),
                    require("@/assets/TechnicalSupport/equipment/HeatTreatment/2.png")
                ],
                title: "热处理",
                subTitle: "Heat treatment",
                desc: "退火采用辊底式氮保基保护气氛退火炉，拥有保护气氛网带式辊底炉生产线，推盘式连续渗碳生产线，<br /> 全自动进口感应淬火设备。"
            },
            {
                imgs: [
                    require("@/assets/TechnicalSupport/equipment/Grinding/1.png"),
                    require("@/assets/TechnicalSupport/equipment/Grinding/2.png")
                ],
                title: "磨加工",
                subTitle: "Grinding",
                desc: "采用机器人自动上下料，全面采用自动在线测量，设备工程能力CPK＞1.67。"
            },
            {
                imgs: [
                    require("@/assets/TechnicalSupport/equipment/Assembly/1.png")
                ],
                title: "装配",
                subTitle: "Assembly",
                desc: "全面采用自动生产线，在生产线上对产品性能进行全要素控制，出厂产品在客户统计的PPM值和PTV值 <br />处于一流水平。"
            }
        ]
    },
    //质量保证
    qualityObj: {
        title: "品质保障",
        desc: "公司坚持以顾客为中心，不断引入新的质量管理思想，持续改进，不断完善质量管理体系。严格的质量管理、有效的质量控制和优质的服务，确保了顾客满意度的逐年提升。 先后通过了ISO9002:1994、ISO9001：2000版质量管理体系认证、ISO/TS16949：2002版质量管理体系认证。 建立了健全、严密、有效的质保体系, 并一直坚持对质量管理体系不断改进提升。实行严格的质量管理,确保每一件产品都让用户放心满意。",
        imgs: ["http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2021/12/e3832792-51ac-4714-b5b3-78c7e200ee21.png", "http://mentalhealthfile.oss-cn-beijing.aliyuncs.com/shapingba/2021/12/bfa81bad-6517-4228-97a1-4b359be1736c.png"]
    },
    //人才理念
    conceptObj: {
       populationImg: require('@/assets/rencai.jpg'),
       populationTitle: "人才理念",
	   populationDesc: `长江轴承人才理念：秉承以人为本的核心，尊重知识、尊重人的价值，<br/><br/>
         挖掘和激发人的潜能，给能者舞台和激励，最终实现员工和公司共同成长的人才理念`
    },
    //幸福文化
    happinessCulture: {
        title: `凝聚“爱厂、护厂、兴厂"共识`,
        subTitle: '营造“活力长江、和谐长江、幸福长江“良好氛围'
    },
    //招聘咨询
    contactObj: {
        title: "招聘咨询",
        contactList: [
            "招聘：重庆长江轴承股份有限公司",
            "联系：何丹",
            "电话：023-88069916",
            "邮箱：cjbhr@163.com",
            "地址：重庆市南岸区蔷薇路11号"
        ]
    },
    // 质量体系
    qualitySystem: {
        name: '公司的质量管理体系',
        content: `以IATF16949标准为内核，以VDA6.3、VDA6.5、ISO17025标准做支撑，深度融合QSB+、CQI-9等管理方法， <br/>
        广泛应用APQP、PPAP、FMEA、SPC、MSA、QFD、DOE等先进工具，坚持以顾客关注为焦点追求缺陷预防，<br/>
         坚持以过程方法为导向追求持续改进，实现客户需求和企业发展和谐统一。`,
    },
    // 环境体系
    environmentalSystem: {
        name: '公司的环境体系',
        content: `以ISO14001标准为基础，以法律法规要求为准绳，落实环境因素的识别、评价和控制，强化紧急情况的识别、 <br/>准备和演练，致力于减少噪音、废水、废气、废物的排放，致力于减少水资源、电资源、气资源的消耗，实现社会责任与企业发展和谐统一。`
    },
    // 安全体系
    securitySystem: {
        name: '公司的职业健康安全体系',
        content: `以ISO45001标准为基础，以法律法规要求为准绳，落实危险源的识别、评价和控制，强化紧急情况的识别、准备和演练，<br/> 致力于减少职业危害，致力于减少健康损害，实现员工利益与企业发展和谐统一。`
    }
}



// WEBPACK FOOTER //
// ./src/utils/i18n/langs/zh.js